import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { dAPI } from 'appSrc/api';
import io from 'socket.io-client';
import parseUri from 'parseuri';
import LookupForm from './form';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { XIcon } from 'appSrc/components/UI';
import { complexUpdateProductModal } from 'appSrc/redux/actions/productModalManager';
import style from './styles/style.module.css';

const socketURL = process.env.REACT_APP_SOCKET_API;
const maxTimeout = 8000;

class ProductLookupModal  extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.isOpen != this.props.isOpen && this.state.fetching ) {
            this.setState( { fetching: false } );
        }
    }
    getProductDetails( urlToTest, affiliateInfo, subAffCode ) {
        return new Promise( ( resolve, reject ) => {
            // set timeout for fetching product details
            let timeoutID = setTimeout( () => {
                reject(`Error: Product details request timed out after ${ maxTimeout } milliseconds.`);
            }, maxTimeout );

            let requestData = {
                url: urlToTest,
                parser: this.getParserName( affiliateInfo ),
                affiliateInfo: affiliateInfo,
                subAffCode: subAffCode,
            };

            let client = io.connect( socketURL );
            client.on( 'connect', function () {
                // send data to Socket.IO server
                client.emit( 'getProductDetails', requestData );
            } );
            client.on( 'getProductDetailsResponse', function ( data ) {
                // validate response from Socket.IO server
                window.clearTimeout( timeoutID );
                client.disconnect();
                resolve( data.response.result );
            } );
        } );
    }
    getParserName( affiliateInfo ) {
        if ('affiliate' in affiliateInfo && 'affiliateType' in affiliateInfo.affiliate) {
            return affiliateInfo.affiliate.affiliateType.toLowerCase();
        }
        else {
            return 'generic';
        }
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );

        var uri = parseUri( values.url || '' );
        this.props.findAdvertiser( uri.host )
        .then( ( affiliateInfo ) => {
            var affiliateid = ( affiliateInfo.affiliate || {} ).affiliateid;
            return this.props.getSubAffiliateCode( affiliateid )
            .then( ( subAffiliateInfo ) => {
                var subAffCode = subAffiliateInfo.subAffCode || null;
                return this.getProductDetails( values.url, affiliateInfo, subAffCode );
            } )
            .catch( () => {
                return this.getProductDetails( values.url, affiliateInfo, null );
            } );
        } )
        .then( ( product ) => {
            this.setState( { fetching: false } );
            // pick next modal step based on response and user type
            if( product.scraped ) {
                if( this.props.self.usertype == 'verified creator' ) {
                    this.props.complexUpdateProductModal( {
                        showModal: 'selectionModal',
                        product: product,
                    } );
                } else {
                    this.props.complexUpdateProductModal( {
                        showModal: 'detailsModal',
                        product: product.scraped,
                    } );
                }
            } else {
                this.props.complexUpdateProductModal( {
                    showModal: 'detailsModal',
                    product: product,
                } );
            }
        }, ( err ) => {
            // if the request times out, log the error and show a blank product form
            console.error(err);
            this.props.complexUpdateProductModal( {
                showModal: 'detailsModal',
                product: {
                    description: '',
                    imageArr: [],
                    originalUrl: values.url,
                    price: 0,
                    title: '',
                    url: values.url,
                },
            } );
        } );
    }




    render() {
        const { isOpen, showListOptions } = this.props;
        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Add Product"
            onRequestClose={ this.props.closeModal }
            className={ `modal-popup ${ style.productLookupModal }` }
            overlayClassName='modal-overlay' >
                { this.state.fetching &&
                    <LoadingOverlay />
                }
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div className={ style.modalContent }>
                    <div className={ style.titleBar }>
                        <h2>Add A Product{ !showListOptions ? ' to This List' : '' }</h2>
                        { !showListOptions &&
                            <p>Lists should have at least 3 products</p>
                        }
                    </div>
                    <div className={ style.formWrapper }>
                        <LookupForm nextStep={ this.submitHandler } />
                    </div>
                </div>
            </ReactModal>
        );
    }
}


ProductLookupModal.defaultProps = {
    isOpen: false,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        findAdvertiser: ( domain ) => {
            return dAPI.post( '/affiliates/advrtsr/search', { domain } );
        },
        getSubAffiliateCode: ( affiliateid ) => {
            return dAPI.get( `/affiliates/subaffiliateID/${ affiliateid }` )
            .catch( () => ( { subAffCode: null } ) );
        },
        complexUpdateProductModal: ( newState ) => {
            dispatch( complexUpdateProductModal( newState ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ProductLookupModal );
